// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__73O9y","fade-in":"Logo_fade-in__soXtF","name":"Logo_name__x6rJe","role":"Logo_role__sR-UI","logo":"Logo_logo__3+0Nj"};